import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';

// Recharts
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';

// Icons
import { Smartphone, Monitor } from 'lucide-react';

// Kit
import { Card } from '@/components/ui';

import { MAIN_API_URL } from '../../../configuration';
import { connect } from 'react-redux';

const DevicesComponent = (props) => {

    const { startDate, endDate } = props;

    const { get, response } = useFetch(`${MAIN_API_URL}/stats`, {
        headers: {
            "x-token": `${localStorage.getItem("token")}`
        }
    });

    // Deck palette: interacción/marca en azul, canal Web en verde de éxito.
    const COLORS = ['#0DA15A', '#35C18F'];

    const [data, setData] = useState([]);

    useEffect(() => { getStatsDevices(); }, [startDate, endDate]);

    const getStatsDevices = async () => {
        const resp = await get("/mobile_desktop?startDate=" + startDate + "&endDate=" + endDate);
        if (response.ok) {
            setData([
                { name: 'Mobile', value: ( resp.statsFormat.mobile === 0 && resp.statsFormat.desktop === 0 ) ? 50 : resp.statsFormat.mobile },
                { name: 'Web', value: ( resp.statsFormat.mobile === 0 && resp.statsFormat.desktop === 0 ) ? 50 : resp.statsFormat.desktop },
            ]);
        }
    }

    const bothZero = data[0]?.value === 0 && data[1]?.value === 0;
    const mobileValue = bothZero ? 50 : data[0]?.value;
    const webValue = bothZero ? 50 : data[1]?.value;

    return (
        <Card hover className="flex h-full flex-col p-5 text-left">
            <h2 className="mb-3 text-[17px] font-bold leading-tight tracking-[-0.01em] text-foreground">
                Ingresos desde dispositivos
            </h2>
            <div className="flex flex-1 items-center justify-between gap-4">
                <div className="flex flex-col gap-4">
                    <div className="flex items-center gap-2.5">
                        <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-primary-tint text-primary [&>svg]:size-[18px]">
                            <Smartphone />
                        </span>
                        <span className="text-sm font-medium text-muted-foreground">Celular</span>
                        <span className="deck-kpi text-xl text-foreground">{mobileValue}%</span>
                    </div>
                    <div className="flex items-center gap-2.5">
                        <span className="flex h-9 w-9 items-center justify-center rounded-sm bg-success-tint text-success [&>svg]:size-[18px]">
                            <Monitor />
                        </span>
                        <span className="text-sm font-medium text-muted-foreground">Web</span>
                        <span className="deck-kpi text-xl text-foreground">{webValue}%</span>
                    </div>
                </div>
                <div className="h-[124px] w-[124px] shrink-0">
                    <ResponsiveContainer>
                        <PieChart>
                            <Pie
                                data={ data }
                                cy="50%"
                                innerRadius={ 42 }
                                outerRadius={ 58 }
                                paddingAngle={ 5 }
                                cornerRadius={ 4 }
                                stroke="none"
                                dataKey="value"
                            >
                                {
                                    data?.map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))
                                }
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </Card>
    )
}

const mapStateToProps = state => {
    return {
        startDate: state.employees.filterDates.startDate,
        endDate: state.employees.filterDates.endDate,
    }
}

export default connect(mapStateToProps, null)(DevicesComponent);
